module.exports = __webpack_public_path__ + "img/aParty_091123_A.ae3f6268.jpg";